import styled from 'styled-components';

export const CardTag = styled.article`
  position: relative;

  color: ${({ theme }) => theme.black};
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  overflow: hidden;

  &:hover h3 {
    color: ${({ theme }) => theme.blue};
  }

  @media(min-width: 700px) {
    display: flex;
  }
`;

export const CardImageContainer = styled.header`
  position: relative;

  height: 150px;
  background-color: #eeeeee;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media(min-width: 700px) {
    width: 36%;
    flex-shrink: 0;
    height: 250px;
  }

  @media(min-width: 900px) {
    width: 35%;
    height: 250px;
  }
`;

export const CardType = styled.span`
  position: absolute;
  top: 0;
  left: 0;

  padding: 5px 10px;

  font-weight: 700;
  font-size: 12px;
  line-height: 1;
  text-align: center;
  color: ${({ theme }) => theme.white};

  border-radius: 6px 0 6px 0;

  background-color: ${({ theme, type }) => {
    switch (type) {
      case "Festive":
        return theme.red;
      case "Tranquil":
        return theme.green;
      case "Family":
        return theme.blue;
      default:
        return theme.blue;
    }
  }};
`;

export const CardDiscount = styled.span`
  position: absolute;
  bottom: 0;
  left: 0;

  padding: 7px 10px;

  font-weight: 700;
  font-size: 16px;

  background-color: ${({ theme }) => theme.yellow};
  box-shadow: 0 0 20px rgba(254, 211, 45, 0.24);
  border-top-right-radius: 6px;
`;

export const CardInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  flex-grow: 1;
  padding: 15px 10px;

  @media(min-width: 700px) {
    padding: 30px 40px;
    flex-direction: column;
    align-items: flex-start;
    flex-wrap: nowrap;
  }
`;

export const CardHotelInfo = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 10px;

  @media(min-width: 700px) {
    justify-content: flex-start;
    margin-bottom: 20px;
  }

  @media(min-width: 900px) {
    margin-bottom: 10px;
  }
`;

export const CardHeading = styled.h3`
  width: 100%;
  margin: 0;
  margin-bottom: 5px;
  padding: 0 5px;

  font-size: 18px;
  line-height: 21px;

  transition: color 0.3s;

  @media(min-width: 700px) {
    margin-bottom: 15px;
    padding: 0;

    font-size: 24px;
  }
`;

export const CardWay = styled.span`
  margin-right: 10px;
  margin-bottom: 5px;
  padding: 3px 10px;

  font-size: 12px;
  line-height: 1;
  color: ${({ theme }) => theme.white};

  background-color: ${({ theme }) => theme.blue};
  border-radius: 50px;

  @media(min-width: 700px) {
    order: 0;
    margin-right: 0;

    font-size: 14px;
  }

  @media(min-width: 900px) {
    padding: 3px 12px;
  }
`;

export const CardDescription = styled.p`
  margin: 0;
  padding: 0 5px;

  font-size: 12px;
  line-height: 16px;

  @media(min-width: 700px) {
    padding: 0;

    font-size: 16px;
    line-height: 22px;
  }
`;

export const CardLocation = styled.span`
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 5px;

  font-size: 12px;
  line-height: 1;

  svg {
    transform: scale(0.66);
    margin-right: 2px;
    fill: ${({ theme }) => theme.blue};
  }

  @media(min-width: 700px) {
    order: 1;
    width: auto;
    margin-top: 0;
    margin-left: 5px;
    margin-right: auto;

    font-size: 14px;

    svg {
      transform: scale(0.8);
      margin-right: 8px;
    }
  }

  @media(min-width: 900px) {
    margin-left: 10px;

    svg {
      margin-right: 5px;
    }
  }
`;

export const CardFooter = styled.footer`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 10px;

  @media(min-width: 700px) {
    margin-top: auto;
  }
`;

export const CardRatingWrapper = styled.span`
  display: flex;

  color: ${({ theme }) => theme.blue};

  svg {
    width: 50px;
    margin-top: -2px;
    fill: ${({ theme }) => theme.blue};
  }

  @media(min-width: 700px) {
    order: 2;

    svg {
      width: auto;
      margin-top: 0;
    }
  }
`;

export const CardVotes = styled.p`
  margin: 0;
  margin-right: 5px;
  padding: 0;

  font-size: 12px;

  @media(min-width: 700px) {
    font-size: 14px;
  }
`;

export const Availability = styled.p`
  margin: 0;
  margin-left: auto;
  margin-right: 10px;
  padding: 5px 10px;

  font-weight: 700;
  font-size: 11px;
  line-height: 1;
  white-space: nowrap;

  border-radius: 50px;

  background-color: ${({ $scarcity, $unavailable }) => {
    if ($scarcity) return '#ff6b35';
    if ($unavailable) return '#9aa5b1';
    return '#bbe9ff';
  }};
  color: ${({ $scarcity, $unavailable }) => ($scarcity || $unavailable ? '#fff' : 'inherit')};

  @media(min-width: 700px) {
    margin-right: 15px;
    padding: 7px 15px;
    font-size: 14px;
  }
`;

export const CardPrice = styled.p`
  margin: 0;
  margin-right: 5px;
  padding: 0;

  font-weight: 700;
  font-size: 14px;
  line-height: 1;
  color: ${({ theme }) => theme.blue};

  span {
    font-size: 21px;
  }

  @media(min-width: 700px) {
    margin-right: 0;

    font-size: 16px;

    span {
      font-size: 25px;
    }
  }

  @media(min-width: 900px) {
    font-size: 17px;

    span {
      font-size: 25px;
    }
  }
`;

export const CrossedPrice = styled.span`
  margin: 0;
  margin-left: auto;
  margin-right: 10px;
  padding: 0;

  font-size: 12px;
  text-decoration: line-through;

  @media(min-width: 700px) {
    margin-right: 5px;

    font-size: 16px;
  }
`;

export const CardWithDiscountPrice = styled.p`
  margin: 0;
  padding: 5px 10px;

  font-weight: 700;
  font-size: 14px;
  line-height: 1;

  background-color: ${({ theme }) => theme.yellow};
  border-radius: 50px;

  span {
    font-size: 21px;
  }

  @media(min-width: 700px) {
    padding: 5px 15px;
    font-size: 16px;

    span {
      font-size: 25px;
    }
  }
`;

export const FeaturesList = styled.ul`
  display: flex;
  flex-wrap: wrap;

  li {
    display: flex;
    align-items: center;

    &:not(:last-child) {
      margin-right: 5px;
    }

    svg {
      transform: scale(0.8);
    }
  }

  @media(min-width: 700px) {
    width: auto;
    margin-bottom: 0;

    li {
      &:not(:last-child) {
        margin-right: 10px;
      }

      svg {
        transform: none;
      }
    }
  }
`;
